import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
    selector: 'app-action',
    template: `
  <button title="Edit" *ngIf="!params?.hideEdit && params?.edit" (click)="edit($event);" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="    padding: .1rem 0.4rem;
    margin: 0rem;
    border-radius: 5px;
    box-shadow: none;
    background-color: rgba(0, 127, 0, 15%) !important;
    color: #007F00 !important;
    font-size: 15px;"  [disabled]="!hasPermission(128)">
    <!-- <i class="fas fa-pencil-alt"></i> -->
    <i class="fas fa-edit"></i>
  </button>
  <button title="Delete" *ngIf="params?.delete"  (click)="delete($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="    padding: .1rem 0.4rem;
    margin: 0rem;
    margin-left:5%;
    border-radius: 5px;
    box-shadow: none;
    background: #d7192030!important;
    color: #d71920 !important;
    font-size: 15px;" [disabled]="!hasPermission(129)">
    <i class="far fa-trash-alt"></i>
  </button>
  <button
  title="Deviation"
  *ngIf="params?.showDeviation && params?.deviation"
  (click)="deviation($event)"
  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
 style="    padding: .1rem 0.4rem;
    margin: 0rem;
    margin-left:5%;
    border-radius: 5px;
    box-shadow: none;
    background: #ff980030 !important;
    color: #ff9800 !important;
    font-size: 15px;     opacity: {{ params?.deviationDisabled ? 0.5 : 1 }};
    cursor: {{ params?.deviationDisabled ? 'not-allowed' : 'pointer' }};
">
  <i class="fas fa-random"></i>
</button>
<button
  title="Self Assign"
  *ngIf="params?.userAssign"
  (click)="userAssign($event)"
  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
  style="
    padding: .1rem 0.4rem;
    margin: 0rem;
    margin-left:5%;
    border-radius: 5px;
    box-shadow: none;
    background: #2196f330 !important;
    color: #2196f3 !important;
    font-size: 15px;"
>
  <i class="fas fa-user-plus"></i>
</button>

  <button
    title="Action"
    *ngIf="params?.action"
    (click)="takeAction($event)"
    class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
    style="padding: .1rem 0.4rem; margin: 0rem; margin-left:5%; border-radius: 5px; box-shadow: none; background: #4caf5030 !important; color: #4caf50 !important; font-size: 15px;"
 
  >
    <i class="fas fa-play"></i> 
  </button>
  
  <button
    title="Outcome"
    *ngIf="params?.outcome"
    (click)="Outcome($event)"
    class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
    style="padding: .1rem 0.4rem; margin: 0rem; margin-left:5%; border-radius: 5px; box-shadow: none; background: #ff980030 !important; color: #ff9800 !important; font-size: 15px;"
   
  >
    <i class="fas fa-chart-line"></i>
  </button>

    <button
    title="Start Workflow"
    *ngIf="params?.startWorkflow"
    (click)="onStartWorkflow($event)"
    class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
    style="padding: .1rem 0.4rem; margin: 0rem; margin-left:5%; border-radius: 5px; box-shadow: none; background: #4caf5030 !important; color: #4caf50 !important; font-size: 15px;"
 
  >
    <i class="fas fa-play"></i> 
  </button>
  <button
  title="Change Status"
  *ngIf="params?.statusChange"
  (click)="statusChange($event)"
  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
  style="
    padding: .1rem 0.4rem;
    margin: 0rem;
    margin-left:5%;
    border-radius: 5px;
    box-shadow: none;
    background: #673ab730 !important;
    color: #673ab7 !important;
    font-size: 15px;"
>
  <i class="fas fa-exchange-alt"></i>
</button>

`,
    standalone: false
})
 
export class AgGridActionbutton implements ICellRendererAngularComp {

  params: any;
    label: string;
    permissions: any[] = [];

    agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
    this.permissions = this.params.values || [];
    }

   refresh(params?: any): boolean {
    return true;
   }

   hasPermission(buttonId: number): boolean {
    // Check if 'screen' exists in the permissions array
    const hasScreen = this.permissions.some(permission =>
        typeof permission === 'string' && permission.includes('screen')
    );

    // If 'screen' is not present, enable all buttons
    if (!hasScreen) {
        return true;
    }

    // Otherwise, check if the specific buttonId is in the permissions list
    return this.permissions.includes(buttonId);
   }


  edit($event) {
    console.log("----------------")
    console.log($event)
    console.log("-------------------")
    if (this.params.edit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.edit(params);

    }
  }
  delete($event) {
    if (this.params.delete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.delete(params);

    }
  }
  deviation($event){
     console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.deviationDisabled) {
    return; 
  }
    if (this.params?.deviation instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.deviation(params);
    }

  }
  userAssign($event: any) {
  if (this.params?.userAssign instanceof Function) {
    const params = {
      event: $event,
      rowData: this.params.node.data
    };
    this.params.userAssign(params);
  }
}

takeAction($event: any) {
    if (this.params?.action instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.action(params);
    }
  }
  
  Outcome($event: any) {
    if (this.params?.outcome instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.outcome(params);
    }
  }

  onStartWorkflow($event: any) {
    event.stopPropagation(); // ✅ prevent row click
    if (this.params?.startWorkflow instanceof Function) {
      
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.startWorkflow(params);
    }
  }
  statusChange($event: any) {
  if (this.params?.statusChange instanceof Function) {

    const params = {
      event: $event,
      rowData: this.params.node.data
    };

    this.params.statusChange(params);
  }
}

}